// Core
import React, {useEffect} from "react"
import { isMobile } from "react-device-detect"

// Utils
import { getLongestWordLength } from "../../utils/strings"

// Components
import ScrollSection from "../locomotiveScroll/scrollSection"
import JsonText from "../_jsonText"

// Style
import styles from "./article.module.scss"

const Article = ({ count, scrollEvent, contentful_id, menuTitle, authorImage, heading, subheading, content, authorBio }) => {
  const anchorOverride = menuTitle ? menuTitle.replace(/\s+/g, '-').toLowerCase() : null

  useEffect(() => {
    setTimeout(() => {
      if (!isMobile && scrollEvent) {
        window.scroll.on('call', (value, way, obj) => {
          if (value === "essay-" + contentful_id) scrollEvent(way, count, obj)
        })
      }
    }, 200)
  }, [])

  const headingModifier = getLongestWordLength(heading) > 9

  return (
    <ScrollSection>
      <div
        id={`ep-${anchorOverride ? anchorOverride : "essay"}`}
        className={`${styles.wrap} container`}
        data-scroll
        data-scroll-call={`essay-${contentful_id}`}
        data-scroll-offset="30%, 30%"
        >
        <div className={`cols flex flex--center`}>
          <div className={`col m12 tp10 t9 d8 dl8`}>
            <div className={styles.header}>
              {authorImage && (
                <img src={authorImage.fluid.src} width={280} height={380} alt={authorImage.description} data-scroll data-scroll-speed="1" />
              )}
              <h2 className={headingModifier ? "small" : ""}>{heading}</h2>
              <p className={`mono`}>{subheading}</p>
            </div>
            <div className={styles.content}>
              <JsonText {...content} />
            </div>
            {authorBio && (
              <div className={styles.bio}>
                <JsonText {...authorBio} />
              </div>
            )}
          </div>
        </div>
      </div>
    </ScrollSection>
  )
}

export default Article